import { render, staticRenderFns } from "./MobileServiceOverview.vue?vue&type=template&id=4bf9f380&scoped=true"
import script from "./MobileServiceOverview.vue?vue&type=script&lang=js"
export * from "./MobileServiceOverview.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/components/mobile-service-overview.css?vue&type=style&index=0&id=4bf9f380&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9f380",
  null
  
)

export default component.exports